import {
  IntakeSummaryConnected,
  PreVisitSummaryCardConnected,
  ProviderEventType,
  useSetCoachConversation,
} from '@grow-therapy-team/seedling-components';

import { AppointmentType } from '../../schedule-preview/types';
import { useOpenIntakeFormResponseCallback } from '../useOpenIntakeFormResponseCallback';
import { usePreVisitSummaryCardWrapper } from './usePreVisitSummaryCardWrapper';

export function PreVisitSummaryCardWrapper() {
  const {
    appointmentShortId,
    patientShortId,
    appointmentType,
    nudgeContext,
    preVisitSummaryCardComponent,
    resourceButtonOnClickHandlers,
  } = usePreVisitSummaryCardWrapper();

  const { setCoachConversation } = useSetCoachConversation();
  const openIntakeFormResponse = useOpenIntakeFormResponseCallback();

  if (!appointmentShortId || !patientShortId) {
    return null;
  }

  const isIntakeAppointment = appointmentType === AppointmentType.Intake;

  return (
    <PreVisitSummaryCardConnected
      appointmentShortId={appointmentShortId}
      patientShortId={patientShortId}
      providerViewEventType={ProviderEventType.VIEWED_PRE_VISIT_SUMMARY_NO_MEDICAL_RECORD_TELEHEALTH}
      includeTitle
      clinicalRiskNudgeEnhancementsContext={nudgeContext}
      nudgeContext={nudgeContext}
      preVisitSummaryCardComponent={preVisitSummaryCardComponent}
      onClickUnreadCoachConversation={setCoachConversation}
      resourceButtonOnClickHandlers={resourceButtonOnClickHandlers}
      betweenNudgesAndContent={
        isIntakeAppointment ? (
          <IntakeSummaryConnected
            appointmentShortId={appointmentShortId}
            showViewFullIntakeButton
            isInverse
            onViewFullIntake={() => {
              void openIntakeFormResponse({ patientShortId });
            }}
          />
        ) : undefined
      }
      isInverse
    />
  );
}
